import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './styles/globals.css'

// Set favicon dynamically using the Pathkit logo
const setFavicon = () => {
  // Remove existing favicons
  const existingFavicons = document.querySelectorAll('link[rel*="icon"]');
  existingFavicons.forEach(link => link.remove());

  // Create Pathkit logo SVG favicon - simplified P icon
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <rect width="100" height="100" fill="#12212e"/>
      <path fill="#ffffff" d="M30 20 L55 20 C68 20 75 27 75 40 C75 53 68 60 55 60 L45 60 L45 80 L30 80 Z M45 35 L45 45 L52 45 C56 45 58 43 58 40 C58 37 56 35 52 35 Z"/>
    </svg>
  `;
  
  const favicon = document.createElement('link');
  favicon.rel = 'icon';
  favicon.type = 'image/svg+xml';
  favicon.href = 'data:image/svg+xml,' + encodeURIComponent(svg);
  document.head.appendChild(favicon);
};

setFavicon();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
